import BaseCtrl from 'edge/platform/base/BaseCtrl';
import Contact from 'edge/fnol/common/models/Contact';

var fn = function fn($scope, claimViewModel, LocaleService) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.lobExtension = $scope.claimVm.lobs.workersComp;
        $scope.availableEmployees = $scope.claimVm.lobs.workersComp.value.getAvailableContacts();

        var injuryIncident = $scope.lobExtension.value.injuryIncident;

        if (!injuryIncident.injured) {
            injuryIncident.injured = new Contact({
                displayName: 'New person',
                gender: null,
                dateOfBirth: null
            });
        }

        if (!injuryIncident.injured.primaryAddress) {
            injuryIncident.injured.initializePrimaryAddress();
        }

        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
    };

    ctrl.next = function (nextFn) {
        nextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel', 'LocaleService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/wc/controllers/WCWhatCtrl.js
// module id = 1601
// module chunks = 0